// extracted by mini-css-extract-plugin
export var hideEditor = "_j7-2";
export var infoIcon = "_j7-3";
export var label = "_j7-1";
export var labelContainer = "_j7-0";
export var readonlyText = "_j7-4";